
export interface IFtp {
    login:string
    password:string
    port:number
    server:string
    tls:boolean
}


export const getDefaultFtp = ():IFtp => {
    return {        
        login:'',
        password:'',
        port:21,
        server:'',
        tls:false
    }
} 